export default __webpack_public_path__ + "static/media/generic.531e66b6.jpg";